import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';

/**
 * Coupon Sportkryss (addon bet) schema
 */
export const sportkryssSchema = z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]);

/**
 * TS Coupon Sportkryss (addon bet) type
 */
export type SportkryssValues = z.infer<typeof sportkryssSchema>;

export type SportkryssNumber = `${number}`;
export const sportkryssNumberSchema = z.custom<SportkryssNumber>((val: unknown) => {
  if (typeof val !== 'string') {
    return false;
  }

  // 7-digit number as string
  return /^\d{7}$/.test(val);
});

/**
 * TS assert function that checks if value is a valid Sportkryss value.
 *
 * @param value Value to check
 * @returns assertion result
 */
export function isSportkryssValue(value: unknown): value is SportkryssValues {
  if (typeof value !== 'number') {
    return false;
  }

  if (sportkryssSchema.safeParse(value).success) {
    return true;
  }

  return false;
}

export const sportkryssCouponSchema = z.object({
  drawNumber: drawNumberSchema,
  sportkryssNumber: sportkryssNumberSchema,
  sportkryss: sportkryssSchema,
});

export type SportkryssCoupon = z.infer<typeof sportkryssCouponSchema>;
